import React from 'react'

import DNDComponent, {DNDComponentProps} from "../../gd-modules/dnd/dnd-component"
import {ReorderListDirection, ReorderListType} from "./reorder-list-no-div";

type Props = {
    type?       : ReorderListType

    idFunction? : func
    onMove?     : func
    onConfirm?  : func

    children?   : any
} & DNDComponentProps

const debug = false
// const debug = "ReorderItem"

export default class ReorderItem extends DNDComponent<Props> {

    private dragDirection   : any
    private lastMouseEvent  : any

    static defaultProps = _.assign({}, DNDComponent.defaultProps, {
        dragTriggerDelta: 5
    })

    getDNDId = () => {
        return this.props.idFunction ? this.props.idFunction(this.props.data.item) :
            typeof this.props.data.item === "string" ? this.props.data.item : this.props.data.item.id;
    }

    onMouseDown(e: MouseEvent, callback: func) {
        debug && console.log(debug, "onMouseDown", e, this.props.data.item)

        e.stopPropagation() // to stop on topmost item in nested reorder lists

        return super.onMouseDown(e, callback)
    }

    _getDragDirection = (mouseEvent: any): ReorderListDirection | undefined => {
        let res = undefined

        switch (this.props.type) {
            case ReorderListType.VERTICAL     :
                if (this.lastMouseEvent) {
                    if(this.lastMouseEvent.clientY > mouseEvent.clientY)        res = ReorderListDirection.TOP
                    else if(this.lastMouseEvent.clientY < mouseEvent.clientY)   res = ReorderListDirection.BOTTOM
                }
                break

            case ReorderListType.HORIZONTAL   :
                if (this.lastMouseEvent) {
                    if (this.lastMouseEvent.clientX > mouseEvent.clientX)       res = ReorderListDirection.LEFT
                    else if (this.lastMouseEvent.clientX < mouseEvent.clientX)  res = ReorderListDirection.RIGHT
                }
                break
        }

        this.lastMouseEvent = mouseEvent
        return res
    }

    onDraggingOver(draggedItem: any, mouseEvent: MouseEvent) {
        super.onDraggingOver(draggedItem, mouseEvent)
        if (draggedItem.getDNDId() === this.getDNDId()) return // do nothing for same item

        const area = gd.utils.Dom.checkMouseOverRectArea(mouseEvent, this.componentEl.getBoundingClientRect())
        const vType = area.yLine === 1 ? 'above' : 'below'
        const hType = area.xLine === 1 ? 'left' : 'right'

        // determine if drag direction changed
        const dragDirection = this._getDragDirection(mouseEvent)
        const dragDirectionChanged = dragDirection && this.dragDirection !== dragDirection
        if (dragDirection) this.dragDirection = dragDirection

        debug && console.log(debug, "onDraggingOver", dragDirectionChanged, area, vType, hType)

        if (dragDirectionChanged) {
            this.props.onMove && this.props.onMove(mouseEvent, draggedItem.props.data, this.props.data, vType, hType)
        }
    }

    onDraggedOver(draggedItem: any, mouseEvent: MouseEvent) {
        super.onDraggedOver(draggedItem, mouseEvent);

        this.setState({
            isDndHover: true
        });
    }

    onDraggedOut(draggedItem: any, isOnDrop: boolean) {
        super.onDraggedOut(draggedItem, isOnDrop);

        this.setState({
            isDndHover: false
        });
    }

    onDragEnd(mouseEvent: MouseEvent, dx: number, dy: number, dropResult: any) {
        super.onDragEnd(mouseEvent, dx, dy, dropResult);

        this.setState({
            isDndHover: false
        }, ()=>{if(this.props.onConfirm) this.props.onConfirm(this.props.data.item)});
    }

    render() {
        const isDragging = this.isDraggedItem(this.getDNDId())

        const styles: any = {}
        if (isDragging) styles.pointerEvents =  'none'; // to prevent click in child component on drag end;
        const isDragInProgress = this.props.dndManager && this.props.dndManager.isDragging()

        debug && console.log(debug, "render", this.props.data.item.name)

        return (
            <>
                {React.Children.map(this.props.children, child=>
                    React.cloneElement(child, {
                        dndHover            : this.state.isDndHover && !isDragging,
                        dndIsDragged        : isDragging,
                        isMouseEntered      : this.state.isMouseEntered,
                        dndIsDragInProgress : isDragInProgress,
                        style               : styles
                    }))}
            </>
        );
    }
};